import { Anchor } from 'src/design/atoms/Anchor';
import { Box } from 'src/design/atoms/Box';
import { Container } from 'src/design/atoms/Container';
import { List } from 'src/design/atoms/List';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import { Title } from 'src/design/atoms/Title';
import React from 'react';

/**
 * Public, unauthenticated page: "Firetrol Text Messaging Terms of Use".
 * Rendered at /legal/sms-terms (and aliased at /legal/sms) without MSAL —
 * required as the publicly-reachable terms URL for SMS campaign
 * registration. Plain static content: no API calls, no auth, no user
 * context.
 */
export const SmsTerms: React.FC = () => {
  return (
    <Box style={{ minHeight: '100vh' }} bg="gray.0" py="xl">
      <Container size="sm">
        <Stack gap="md">
          <Title order={2}>Firetrol Text Messaging Terms of Use</Title>

          <Text size="sm">
            These terms describe Firetrol's text messaging ("SMS") program for
            employees using the Firetrol Insite application. By opting in
            through the in-app consent flow described below, you consent to
            receive text messages from Firetrol at the phone number you provide,
            and you agree these terms constitute your electronic signature and
            consent under the U.S. Electronic Signatures in Global and National
            Commerce Act (E-SIGN Act).
          </Text>

          <Title order={4}>Message types</Title>
          <Text size="sm">
            Firetrol sends timesheet workflow notifications — timesheet
            submissions, approvals, rejections, and review requests — as well as
            one-time phone verification codes used to confirm your phone number.
            Firetrol does not send marketing or promotional messages through
            this program.
          </Text>

          <Title order={4}>Costs</Title>
          <Text size="sm">Message and data rates may apply.</Text>

          <Title order={4}>Frequency</Title>
          <Text size="sm">Msg frequency varies.</Text>

          <Title order={4}>Opting out</Title>
          <Text size="sm">
            You may opt out of text messages at any time by replying STOP, QUIT,
            END, REVOKE, OPT OUT, CANCEL, or UNSUBSCRIBE to any message you
            receive from Firetrol. You may receive a confirmation SMS after
            opting out. You can also turn text messages off at any time from
            your account profile in the Firetrol Insite application.
          </Text>

          <Title order={4}>Contact us / help</Title>
          <Text size="sm">
            For help with this text messaging program, reply HELP to any message
            you receive from Firetrol, or contact your Firetrol IT support
            channel.
          </Text>

          <Title order={4}>How you opted in</Title>
          <Text size="sm">
            Signed-in Firetrol employees are shown an in-app consent screen
            describing this text messaging program. After reviewing the program
            details and accepting, the employee enters a phone number and
            confirms it by entering a one-time verification code sent to that
            number. Consent is recorded at that time.
          </Text>

          <Title order={4}>Privacy</Title>
          <Text size="sm">
            For information on how Firetrol collects and uses your phone number
            and related data, see our{' '}
            <Anchor href="/legal/privacy">Privacy Policy</Anchor>.
          </Text>
        </Stack>
      </Container>
    </Box>
  );
};
